<template>
  <div id="incomingcalls">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <nav class="navbar fixted-top navbar-light bg-light">
      <div class="navbar-brand">Calls</div>
      <ul class="nav nav-pages mr-auto">
        <li class="nav-item">
          <a class="nav-link active" type="button">summary</a>
        </li>
      </ul>
    </nav>

    <div class="row">
      <div class="column">
        <MetricGraph :metrics='metrics'
          :name='"Total Calls"'
          :date='date'
          :period='period'
          :lastUpdate='lastUpdate'
          v-on:updateMetric='updateMetric' />
      </div>

      <div class="column">
        <div id="numbers" class="numbers-graph" v-if="'calls' in report && report.calls.length > 0">
          <transition name="fade" appear>
            <div class="card">
              <div class="card-heading">
                <h5 class="card-title">Numbers</h5>
              </div>
              <div class="card-body" style="padding: 0;">
                <phone-numbers-bar :numbers="report.from"/>
              </div>
            </div>
          </transition>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="column">

        <div id="timeline" v-if="'calls' in report && report.calls.length > 0">
          <transition name="fade" appear>
            <div class="card">
              <div class="card-heading" style="padding-left: 15px;">
                <h5 class="card-title">Timeline (UTC)</h5>
              </div>
              <div class="card-body" style="padding: 0;">
                <CallsTimeline
                  :period="period"
                  :date='date'
                  :calls="report.calls"/>
              </div>
            </div>
          </transition>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="column">
        <div id="calls" class="calls" v-if="'calls' in report && report.calls.length > 0">
          <transition name="fade" appear>
            <CallLogs :report='report' />
          </transition>
        </div>
      </div>

      <div class="column">
        <div id="stats" v-if="'calls' in report && report.calls.length > 0">
          <transition name="fade" appear>
            <MetricCallLogs :report='report' />
          </transition>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import PhoneNumbersBar from '@/components/charts/PhoneNumbersBar'
import CallLogs from '@/components/CallLogs'
import MetricCallLogs from '@/components/MetricCallLogs'
import MetricGraph from '@/components/MetricGraph'
import CallsTimeline from '@/components/charts/CallsTimeline'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'IncomingCalls',
  components: {
    VueLoading,
    PhoneNumbersBar,
    MetricGraph,
    CallsTimeline,
    CallLogs,
    MetricCallLogs
  },
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  data () {
    return {
      labels: [],
      metrics: [],
      report: {},
      loading: false,
      period: 'week',
      date: null,
      lastUpdate: 'unknown'
    }
  },
  methods: {
    getReport: function () {
      this.loading = true
      this.report = {}
      HTTP.get(`/calls/${this.period}/${this.date}`)
        .then((response) => {
          this.report = response.data
          this.setLabels()
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get incoming calls report : ${msg}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMetrics: function () {
      this.loading = true
      HTTP.get(`/calls/metrics/${this.period}`)
        .then((response) => {
          this.metrics = response.data['metrics']
          this.date = response.data['metrics'][11]['date']
          this.lastUpdate = response.data.metrics[11]['last_update'].toString()
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get incoming calls metrics : ${msg}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateMetric: function (event) {
      switch (event.eventType) {
        case 'date':
          this.lastUpdate = event.data.lastUpdate
          this.date = event.data.date
          break

        case 'period':
          this.period = event.data.period
          break

        default:
          console.log(event)
          break
      }
    },
    setLabels: function () {
      if (this.period === 'week') {
        var startOfWeek = this.$moment(this.date, 'YYYY-WW').startOf('isoWeek')
        let labels = []
        var days = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun']
        days.forEach(function (day, i) {
          labels.push(day + ' (' + startOfWeek.day(i).format('DD/MM') + ')')
        })
        this.labels = labels
      } else if (this.period === 'month') {
        var count = this.$moment(this.date, 'YYYY-MM').daysInMonth()
        this.labels = Array.from({length: count}, (v, k) => k + 1)
      }
    }
  },
  created: function () {
    this.getMetrics()
  },
  watch: {
    period: function () {
      this.getMetrics()
    },
    date: function () {
      this.getReport()
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/incoming-calls.css'></style>



// WEBPACK FOOTER //
// src/views/IncomingCalls.vue